module.exports = __webpack_public_path__ + "img/ai-launcher.b7ddcdd9.svg";